"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertManufacturePartNumber = convertManufacturePartNumber;
exports.getFirstDesignatorFromProblem = getFirstDesignatorFromProblem;
exports.sortMpnProblems = sortMpnProblems;
const shared_1 = require("@buildwithflux/shared");
function convertManufacturePartNumber(schematicElements) {
    return (problem) => {
        const designatorUidMap = {};
        const designator = problem.affectedItems
            .filter(({ type }) => type === "element")
            .map((affectedItem) => {
            const element = schematicElements[affectedItem.uid];
            let componentDesignator;
            if (element?.label && element.label.trim() !== "") {
                componentDesignator = element.label;
            }
            else if (element?.part_version_data_cache?.name &&
                element.part_version_data_cache.name.trim() !== "") {
                componentDesignator = element.part_version_data_cache.name;
            }
            else if (affectedItem.itemLabel && affectedItem.itemLabel.trim() !== "") {
                componentDesignator = affectedItem.itemLabel;
            }
            else {
                componentDesignator = affectedItem.uid.substring(0, 8);
            }
            if (componentDesignator) {
                designatorUidMap[componentDesignator] = affectedItem.uid;
            }
            return componentDesignator;
        })
            .join(", ");
        return { name: designator, designator: designator, mpn: "None", designatorUidMap };
    };
}
function getFirstDesignatorFromProblem(problem, schematicElements) {
    const firstAffectedItem = problem.affectedItems.filter(({ type }) => type === "element").at(0);
    if (!firstAffectedItem) {
        return "";
    }
    const element = schematicElements[firstAffectedItem.uid];
    return firstAffectedItem.itemLabel ?? element?.label ?? firstAffectedItem.uid ?? "";
}
function sortMpnProblems(problems, schematicElements) {
    return [...problems].sort((a, b) => {
        const designatorA = getFirstDesignatorFromProblem(a, schematicElements);
        const designatorB = getFirstDesignatorFromProblem(b, schematicElements);
        return (0, shared_1.naturalSortByProperty)("designator")({ designator: designatorA }, { designator: designatorB });
    });
}
//# sourceMappingURL=manufacturePartNumber.js.map